<template>
  <div class="p-5 flex flex-col">
    <p class="font-semibold text-3xl">
      {{ this.$route.meta.title }}
    </p>
    <div class="p-5 flex flex-col mt-5 bg-white rounded-md">
      <table-top
        is-search-has-border
        :page-size-start="false"
        class="mt-6"
        @fetch="fetchTripStatus"
      >
        <template #start>
          <vs-button
            v-if="isUserCanAccessMenu(permission.name, 'add')"
            class="button shadow-primary font-semibold"
            color="primary"
            @click="() => {
              isAdd = true
              showModalTripStatus = !showModalTripStatus
            }"
          >
            Add Trip Status
          </vs-button>
          <vs-button
            class="button shadow-secondary font-semibold ml-5"
            color="secondary"
            @click="isDownload = true"
            :disabled="isDownload"
          >
            Export Excel
          </vs-button>
        </template>
      </table-top>
      <data-table
        class="mt-6"
        :table-header="header"
        :table-data="datas"
        :sort-by="filters.sort_by"
        :sort-dir="filters.sort_dir"
        :loading="isBusy"
        body-height="auto"
        :expanded-rows-list="expandedRowsList"
        @sort="() => {}"
        is-hide-header
        row-style="background-color: #493493 !important; color: #ffffff !important"
      >
        <template #action="{ row }">
          <div class="flex flex-row gap-x-3">
            <template>
              <div
                v-if="isUserCanAccessMenu(permission.name, 'add')"
                class="p-1 w-8 h-8 self-center flex items-center justify-center bg-secondary rounded cursor-pointer"
                @click="() => {
                  isAddActivity = true
                  showModalKeyActivity = !showModalKeyActivity
                  tempTripStatusData = row
                }"
              >
                <vs-icon
                  icon="add_circle_outline"
                  color="#ffffff"
                  size="22px"
                />
              </div>
              <div
                v-if="isUserCanAccessMenu(permission.name, 'edit')"
                class="p-1 w-8 h-8 self-center flex items-center justify-center bg-white rounded cursor-pointer"
                @click="() => {
                  isAdd = false
                  showModalTripStatus = !showModalTripStatus
                  tempTripStatusData = row
                }"
              >
                <img :src="require('@/assets/shipo-icon-edit-primary.svg')">
              </div>
              <div
                v-if="isUserCanAccessMenu(permission.name, 'delete')"
                class="p-1 w-8 h-8 self-center flex items-center justify-center bg-white rounded cursor-pointer"
                @click="onHandleDelete(row)"
              >
                <img :src="require('@/assets/shipo-icon-delete-primary.svg')">
              </div>
            </template>
          </div>
        </template>
        <template #name="{ row }">
          <template>
            <div
              class="flex justify-start gap-3 cursor-pointer"
              @click="toggleRow(row)"
            >
              <div
                class="self-center flex items-center justify-center bg-white rounded"
              >
                <vs-icon
                  :icon="expandedRowsList.includes(row.id) ? 'keyboard_arrow_down' : 'keyboard_arrow_right'"
                  color="#493493"
                  size="16px"
                />
              </div>
              <div>
                Trip Status: {{ row.name || '-' }}
              </div>
            </div>
          </template>
        </template>
        <template #code="{ row }">
          <div>
            {{ row.code || '-' }}
          </div>
        </template>
        <template #color_code="{ row }">
          <div class="flex items-center justify-center">
            <div
              class="w-5 h-5 mr-1"
              :style="{ backgroundColor: row.color_code }"
            />
            <span>{{ row.color_code }}</span>
          </div>
        </template>
        <template #detail="{ parentData, parentIndex }">
          <div>
            <vs-button
              v-if="isUserCanAccessMenu(permission.name, 'add')"
              class="button shadow-secondary font-semibold w-full"
              color="secondary"
              @click="() => {
                tempKeyActivityData = null
                isAddActivity = true
                showModalKeyActivity = !showModalKeyActivity
                tempTripStatusData = parentData
              }"
            >
              <div class="mt-1 flex items-center gap-3">
                <vs-icon
                  icon="add_circle"
                  color="#ffffff"
                  size="22px"
                /> Add Key Activity
              </div>
            </vs-button>
            <div
              v-if="!parentData.key_activity.length"
              class="m-8 font-bold w-full text-2xl"
            >
              No Data
            </div>
            <data-table
              v-else
              class="mt-6"
              :table-header="headerDetail"
              :table-data="parentData.key_activity"
              :loading="isBusy"
              body-height="auto"
              @sort="() => {}"
            >
              <template #no="{ index }">
                <div class="flex flex-row w-min">
                  {{ index + 1 }}
                </div>
              </template>

              <template #action="{ row, index }">
                <div class="flex flex-row gap-x-3">
                  <template>
                    <div
                      v-if="isUserCanAccessMenu(permission.name, 'add') && isEmpty(search)"
                      class="p-1 w-8 h-8 self-center flex items-center justify-center bg-secondary rounded cursor-pointer"
                      @click="() => {
                        const activityIndex = index + 1
                        const tempActivityData = datas[parentIndex].key_activity
                        tempKeyActivityData = activityIndex === tempActivityData.length ?
                          null : tempActivityData[activityIndex]
                        isAddActivity = true
                        showModalKeyActivity = !showModalKeyActivity
                        tempTripStatusData = parentData
                      }"
                    >
                      <vs-icon
                        icon="add_circle_outline"
                        color="#ffffff"
                        size="22px"
                      />
                    </div>
                    <div
                      v-if="isUserCanAccessMenu(permission.name, 'edit')"
                      class="self-center flex items-center justify-center icon-transparent-bg"
                      @click="() => {
                        isAddActivity = false
                        showModalKeyActivity = !showModalKeyActivity
                        tempTripStatusData = parentData
                        tempKeyActivityData = row
                      }"
                    >
                      <img :src="require('@/assets/shipo-icon-edit.svg')">
                    </div>
                    <div
                      v-if="isUserCanAccessMenu(permission.name, 'delete')"
                      class="self-center flex items-center justify-center icon-transparent-bg"
                      @click="onHandleDelete(row, parentIndex)"
                    >
                      <img :src="require('@/assets/shipo-icon-delete.svg')">
                    </div>
                  </template>
                </div>
              </template>
              <template #order_level="{ row, index }">
                <div
                  v-if="isUserCanAccessMenu(permission.name, 'edit')"
                  class="flex flex-row"
                >
                  <div
                    :class="`mx-1 self-center flex items-center justify-center ${populateChildClassOrderIncrease(index)}`"
                    @click="onHandleChildOrder(row, index, false, parentIndex)"
                  >
                    <img
                      :src="require('@/assets/shipo-icon-double-arrow-up.svg')"
                    >
                  </div>
                  <div
                    :class="`mx-1 self-center flex items-center justify-center ${populateChildClassOrderDecrease(index, parentIndex)}`"
                    @click="onHandleChildOrder(row, index, true, parentIndex)"
                  >
                    <img
                      :src="require('@/assets/shipo-icon-double-arrow-down.svg')"
                    >
                  </div>
                </div>
              </template>
              <template #code="{ row }">
                <div>
                  {{ row.code || '-' }}
                </div>
              </template>
              <template #name="{ row }">
                <div
                  class="capitalize"
                >
                  {{ row.name? row.name.toLowerCase() : '-' }}
                </div>
              </template>
              <template #name_bahasa="{ row }">
                <div>
                  {{ row.name_bahasa || '-' }}
                </div>
              </template>
              <template #description="{ row }">
                <div>
                  {{ row.description || '-' }}
                </div>
              </template>
              <template #type="{ row }">
                <div>
                  {{ row.type || '-' }}
                </div>
              </template>
              <template #visibility="{ row }">
                <template>
                  <div
                    class="badge-trip-status"
                  >
                    {{ row.visibility }}
                  </div>
                </template>
              </template>
              <template #icon="{ row }">
                <template>
                  <img
                    :src="row.icon ? row.icon.thumbnail :''"
                    alt=""
                    width="20"
                  >
                </template>
              </template>
            </data-table>
          </div>
        </template>
      </data-table>
      <table-bottom
        class="mt-6"
        @fetch="fetchTripStatus"
      />
    </div>
    <pop-up
      :active.sync="popUp.isShown"
      is-warning
      :title="`Delete ${popUp.parentIndex > -1 ? 'Key Activity' : 'Trip Status'}`"
      left-button="Cancel"
      right-button="Yes, Delete"
      :is-busy="isProcessing"
      @close="popUp = { isShown: false, parentIndex: null, tempId: null, tempName: '' }"
      @leftButton="popUp = { isShown: false, parentIndex: null, tempId: null, tempName: '' }"
      @rightButton="deleteAction"
    >
      <p class="text-center mt-1">
        Are you sure you want to delete trip status "{{ popUp.tempName }}"?
      </p>
      <p class="text-center">
        All sub-levels items will also be deleted and cannot be undone.
      </p>
    </pop-up>
    <pop-up
      :active.sync="popUpSuccess"
      @close="resetTableFilter"
      @ok="resetTableFilter"
      title="Success"
    >
      {{ `${popUp.parentIndex > -1 ? 'Key Activity' : 'Trip Status'} successfully deleted.` }}
    </pop-up>
    <modal-trip-status
      :active.sync="showModalTripStatus"
      :trip-status-data="tempTripStatusData"
      :is-add="isAdd"
      @action="closeTripStatusModal"
      @close="showModalTripStatus = true"
    />
    <modal-key-activity
      :active.sync="showModalKeyActivity"
      :trip-status-data="tempTripStatusData"
      :key-activity-data="tempKeyActivityData"
      :is-add="isAddActivity"
      @action="closeKeyActivityModal"
      @close="showModalKeyActivity = true"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import api from '@/api/index';
import DataTable from '@/components/dataTable'
import PopUp from '@/components/popUp'
import TableBottom from '@/components/tableBottom'
import TableTop from '@/components/tableTop'
import { PAGE_TITLE } from '@/fixtures/Constants'
import downloadUtils from '@/utils/downloadUtils'

import ModalKeyActivity from './ModalKeyActivity'
import ModalTripStatus from './ModalTripStatus'

export default {
  metaInfo() {
    return {
      title: `${PAGE_TITLE} ${this.$route.meta.title}`
    }
  },
  components: {
    DataTable,
    TableBottom,
    TableTop,
    PopUp,
    ModalTripStatus,
    ModalKeyActivity
  },
  data: () => ({
    isProcessing: false,
    isBusy: false,
    header: [
      { key: 'action', label: 'Action', sortable: false, width: '75px' },
      { key: 'name', label: 'Name'},
      { key: 'code', label: 'Code' },
      { key: 'color_code', label: 'Color', sortable: false }
    ],
    headerDetail: [
      { key: 'action', label: 'Action', sortable: false, width: '75px' },
      { key: 'order_level', label: 'Order Level', sortable: false, width: '75px' },
      { key: 'code', label: 'Key Activity Code' },
      { key: 'name', label: 'Status Name (English)'},
      { key: 'name_bahasa', label: 'Status Name (Indonesia)' },
      { key: 'visibility', label: 'Visibility' },
      { key: 'icon', label: 'Icon' }
    ],
    datas: [],
    filters: {
      sort_by: '',
      sort_dir: '',
      is_active: null
    },
    popUp: {
      isShown: false,
      parentIndex: null,
      tempId: null,
      tempName: ''
    },
    popUpSuccess: false,
    expandedRowsList: [],
    isDownload: false,
    showModalTripStatus: false,
    isAdd: false,
    tempTripStatusData: null,
    showModalKeyActivity: false,
    isAddActivity: false,
    tempKeyActivityData: null
  }),
  computed: {
    ...mapGetters({
      tripStatuses: 'KeyActivityStatus/tripStatusData',
      tripStatusOptions: 'KeyActivityStatus/tripStatusOptions',
      visibilityOptions: 'KeyActivityStatus/visibilityOptions',
      typeActivityOptions: 'KeyActivityStatus/typeActivityOptions',
      currentPage: 'Table/currentPage',
      pageSize: 'Table/pageSize',
      totalData: 'Table/totalData',
      totalPage: 'Table/totalPage',
      search: 'Table/search',
      fileExport: 'KeyActivityStatus/fileExport'
    }),
    permission() {
      return { page: this.$route.meta.permission.page, name: this.$route.meta.permission.name, sub: this.$route.meta.permission.sub }
    }
  },
  watch: {
    tripStatuses: {
      handler(val) {
        if (val) {
          this.datas = val
        }
        this.isBusy = false
      }
    },
    isDownload: {
      handler(val) {
        if (val) {
          this.exportKeyActivity()
        }
      }
    },
    fileExport: {
      handler(val) {
        if (!this.isEmpty(val)) {
          downloadUtils(val, `KeyActivityStatus.xlsx`)
          this.$store.dispatch('KeyActivityStatus/resetKeyActivityFileExport')
        }
      }
    },
    isActionColumnVisible: {
      immediate: true,
      handler(val) {
      }
    }
  },
  mounted() {
    this.fetchOeeLv2()
    this.fetchVisibility()
  },
  methods: {
    closeTripStatusModal() {
      this.showModalTripStatus = false
      this.tempTripStatusData = null
      this.resetTableFilter()
    },
    closeKeyActivityModal() {
      this.showModalKeyActivity = false
      this.tempTripStatusData = null
      this.tempKeyActivityData = null
      this.resetTableFilter()
    },
    populateChildClassOrderIncrease(index) {
      if (index === 0 || !this.isEmpty(this.search)) {
        return 'icon-disable-bg'
      }

      return 'icon-transparent-bg'
    },
    populateChildClassOrderDecrease(index, parentIndex) {
      if (index === this.datas[parentIndex]?.key_activity?.length-1 || !this.isEmpty(this.search)) {
        return 'icon-disable-bg'
      }
      
      return 'icon-transparent-bg'
    },
    async onHandleChildOrder(row, index, isDecrement, parentIndex) {
      if (!this.isEmpty(this.search)) return
      if (index === 0 && !isDecrement) return
      if (index === this.datas[parentIndex]?.key_activity?.length-1 && isDecrement) return

      const otherDataIdx = isDecrement ? index + 1 : index - 1

      const formDataFirst = {
        id: row.id,
        form: {
          name: row.name,
          name_bahasa: row.name_bahasa,
          code: row.code,
          order_level: this.datas[parentIndex].key_activity[otherDataIdx].order_level,
          is_active: row.is_active,
          visibility: row.visibility,
          type: row.type,
          oee_id: row.oee_id
        }
      }

      const formDataSecond = {
        id: this.datas[parentIndex].key_activity[otherDataIdx].id,
        form: {
          name: this.datas[parentIndex].key_activity[otherDataIdx].name,
          name_bahasa: this.datas[parentIndex].key_activity[otherDataIdx].name,
          code: this.datas[parentIndex].key_activity[otherDataIdx].code,
          order_level: row.order_level,
          visibility: this.datas[parentIndex].key_activity[otherDataIdx].visibility,
          type: this.datas[parentIndex].key_activity[otherDataIdx].type,
          oee_id: this.datas[parentIndex].key_activity[otherDataIdx].oee_id
        }
      }

      try {
        await this.$store.dispatch('KeyActivityStatus/putKeyActivity', formDataFirst)
        await this.$store.dispatch('KeyActivityStatus/putKeyActivity', formDataSecond)

        this.showSuccessNotification(this, 'Status Order Level successfully updated.')
        this.datas = []
        this.fetchTripStatus()
      } catch (error) {
        this.showFailedNotification(this, `Failed to update Status Order Level, please try again`, 'Error')
      }
    },
    toggleRow(tr) {
      const index = this.expandedRowsList.indexOf(tr.id);
      if (index > -1) {
        tr.isExpand = false
        this.expandedRowsList.splice(index, 1); // Collapse
      } else {
        tr.isExpand = true
        this.expandedRowsList.push(tr.id); // Expand
      }
    },
    async fetchTripStatus() {
      try {
        this.isBusy = true
        const apiFilters = {
          is_master_data: true,
          page: this.currentPage || 1,
          limit: this.pageSize || 10
        };

        await this.$store.dispatch('KeyActivityStatus/fetchTripStatus', apiFilters)
      } catch (e) {
        this.isBusy = false
        this.showFailedNotification(this, 'Failed to fetch Trip Status list, please try again')
      }
    },
    async fetchOeeLv2() {
      try {
        await this.$store.dispatch('KeyActivityStatus/getOeeLvl2');
      } catch (error) {}
    },
    async fetchVisibility() {
      try {
        await this.$store.dispatch('KeyActivityStatus/getVisibilityOptions');
      } catch (error) {}
    },
    onHandleDelete(row, parentIndex) {
      this.popUp = { isShown: true, parentIndex: parentIndex , tempId: row.id, tempName: row.name }
    },
    async deleteAction() {
      try {
        this.isProcessing = true
        if (this.popUp.parentIndex > -1) {
          await this.$store.dispatch('KeyActivityStatus/deleteKeyActivity', this.popUp.tempId)
        } else {
          await this.$store.dispatch('KeyActivityStatus/deleteTripStatus', this.popUp.tempId)
        }

        this.popUp = { isShown: false, parentIndex: false, tempId: null, tempName: '' }
        this.popUpSuccess = true
        this.isProcessing = false
      } catch (e) {
        this.isProcessing = false
        this.popUp = { isShown: false, parentIndex: false, tempId: null, tempName: '' }
        this.showFailedNotification(
          this,
          `Failed to delete ${this.popUp.parentIndex > - 1 ? 'Key Acitivity' : 'Trip Status'}, please try again`
        )
      }
    },
    async resetTableFilter() {
      await this.fetchTripStatus()
      this.popUpSuccess = false
    },
    async exportKeyActivity() {
      try {
        this.isBusy = true
        await this.$store.dispatch('KeyActivityStatus/exportKeyActivity', {}, {
          headers: {
            accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          },
          resposnseType: 'blob'
        })
        this.isDownload = false
        this.isBusy = false
      } catch (error) {
        this.isBusy = false
        this.isDownload = false
        this.showFailedNotification(this, 'Failed to download Key Activity Status, please try again')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.icon-transparent-bg {
  @apply cursor-pointer;
  @apply min-w-8;
  @apply h-8;
  @apply bg-primary;
  border-radius: 0.5rem;

  &.complete {
    background-color: #D1F9E3;
  }

  &.delete {
    background-color: rgba(255, 99, 123, 0.16);
  }
}

.icon-disable-bg {
  @apply cursor-pointer;
  @apply min-w-8;
  @apply h-8;
  border-radius: 0.5rem;

  background-color: #646464;
}

.badge-status {
  background-color: #4CAF50;
  color: #4CAF50;
  text-align: center;
  padding: 5px 0;
  border-radius: 5px;

  &.inactive {
    background-color: #DB1111;
    color: #DB1111;
  }
}
</style>
